<template>
  <BModal
    hide-header
    hide-footer
    hide-header-close
    :centered="true"
    v-bind="$attrs"
    lazy
    body-class="p-0"
  >
    <div class="flex flex-col justify-center items-center text-center gap-8 px-[32px] py-[30px]">
      <div class="flex flex-col gap-[4px]">
        <h4 class="font-semibold text-[24px] text-black">
          Konfirmasi Ban Akun
        </h4>
        <p class="text-[16px] text-[#626262]">
          Yakin ingin ban akun ini? Akses partner akan dibatasi permanen atau sementara.
        </p>
      </div>

      <!-- textarea -->
      <div class="w-full text-left">
        <label class="text-sm font-medium mb-1 block text-[#333333]">Alasan Ban Akun</label>
        <BFormTextarea
          v-model="alasan"
          placeholder="Tuliskan alasan spesifik mengapa akun ini diblokir..."
          :maxlength="255"
          rows="4"
        />
        <div class="text-right text-xs text-gray-400 mt-1">
          {{ alasan.length }}/255
        </div>
      </div>

      <div class="flex justify-center items-center gap-[12px] w-full mt-2">
        <BButton
          variant="outline-primary"
          class="flex-[45%]"
          @click="handleCancel()"
        >
          Batal
        </BButton>
        <BButton
          variant="primary"
          class="flex-[45%]"
          :disabled="alasan.trim().length < 10"
          @click="handleConfirm()"
        >
          Lanjutkan
        </BButton>
      </div>
    </div>
  </BModal>
</template>

<script>
export default {
  data() {
    return {
      alasan: '',
    }
  },
  methods: {
    handleCancel() {
      this.alasan = ''
      this.$emit('on-click-cancel-button')
    },

    handleConfirm() {
      this.$emit('on-click-confirm-button', this.alasan)
      this.alasan = ''
    },
  },
}
</script>
